'use client';
import { createContext, useContext } from 'react';
import type { SiteConfig } from '@/lib/site-config';

/**
 * Makes the server-resolved per-subdomain SiteConfig available to client
 * components (logo, site name, theme). Fed once from the root layout.
 */
const SiteContext = createContext<SiteConfig | null>(null);

const DEFAULT_SITE: SiteConfig = {
  httpHost: '',
  cusGroup: null,
  adminEmail: null,
  siteName: 'MomoSpace',
  theme: 'light',
  defaultPage: null,
  isDefault: true,
  hasLogo: false,
  logoUrl: '/api/site/logo',
  loginTitle: null,
  loginSubtitle: null,
  signinText: null,
  heroHeadline: null,
  heroSubtitle: null,
  footerText: null,
  sidebarText: null,
  topbarText: null,
  tabTitle: null,
  hiddenPages: [],
  manuals: [],
  manualUrl: null,
  manualPdfUrl: null,
};

export function SiteProvider({
  value,
  children,
}: {
  value: SiteConfig;
  children: React.ReactNode;
}) {
  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export function useSite(): SiteConfig {
  return useContext(SiteContext) ?? DEFAULT_SITE;
}
